import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import smoothscroll from 'smoothscroll-polyfill';
import App from './app';
import './styles/global.scss';

// polyfill for window.scrollTo() behaviour: "smooth"
smoothscroll.polyfill();

const root = createRoot(document.getElementById('react-app')!);
root.render(<App />);
